module.exports = __webpack_public_path__ + "article-7051a3ee/kuendigung-fe6ef5b738e1ee280f14fd2919dee60a.jpeg";